// import { Locale } from 'App/i18n' throws error we need to make a research the error
import { DomainTranslations } from 'App/i18n';
import { Locale } from 'App/i18n/enums';
import esAR from './statistics.es-AR.json';
import esMX from './statistics.es-MX.json';
import ptBR from './statistics.pt-BR.json';

const dashboardTranslations: DomainTranslations = {
  name: 'statistics',
  languages: {
    [Locale.ARGENTINA]: esAR,
    [Locale.MEXICO]: esMX,
    [Locale.BRAZIL]: ptBR,
  },
};

export default dashboardTranslations;
